/** @jsx jsx */
/** @jsxRuntime classic */
import { jsx } from '@emotion/react';
import React, { CSSProperties, useMemo } from 'react';
import useTheme from '../style/useTheme';
import { SxProp } from '../style/sxProp';

export type Props = React.PropsWithChildren<{
  style?: CSSProperties;
  sx?: SxProp;
}> &
  Pick<JSX.IntrinsicElements['div'], 'id' | 'aria-labelledby'>;

const InputContainer: React.FC<Props> = ({ sx, style, children, ...rest }) => {
  const { resolveCSS } = useTheme();

  const css = useMemo(
    () =>
      resolveCSS({
        width: '100%',
        '&:not(:only-of-type)': {
          marginBottom: '2',
        },
        ...style,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        ...(sx as any),
      }),
    [resolveCSS, style, sx]
  );
  return (
    <div className="origami-inputContainer" css={css} {...rest}>
      {children}
    </div>
  );
};

export default InputContainer;
